<template>
  <div class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500" id="#kt_aside_menu" data-kt-menu="true">
    <MenuItem :menu="menuClinic.dashboard">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor" />
          <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor" />
          <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor" />
          <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor" />
        </svg>
      </template>
    </MenuItem>
    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">{{ $t('Usuário') }}</span>
      </div>
    </div>
    <!-- begin:CLINIC -->
    <MenuItem :menu="menuClinic.favoritos" :defaultOpen="true" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:CLINIC -->
    <!-- begin:CASH -->
    <MenuItem :menu="menuCash.favoritos" v-if="fgSistema == 'CASH'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:CASH -->
     <!-- begin:BOT -->
    <MenuItem :menu="menuBot.favoritos" v-if="fgSistema == 'BOT'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:BOT -->
    <!-- begin:Analytics -->
    <MenuItem :menu="menuAnalytics.favoritos" v-if="fgSistema == 'ANALYTICS'">  
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:Analytics --> 
    <!-- begin:QUALITY -->
    <MenuItem :menu="menuQuality.favoritos" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:QUALITY -->
    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7" style="cursor: pointer;" @click="collapseAcessos = !collapseAcessos">
          {{ $t('Acessos') }} 
          <i 
            v-if="collapseAcessos" 
            class="ki-duotone ki-plus-square" 
            style="font-size: 14px; vertical-align: text-bottom; margin-left: 2px;" 
          >
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <i 
            v-if="!collapseAcessos" 
            class="ki-duotone ki-minus-square" 
            style="font-size: 14px; vertical-align: text-bottom; margin-left: 2px;" 
          >
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </span>
      </div>
    </div>
    <transition enter-active-class="animate__animated animate__fast animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" mode="out-in">
      <div v-show="!collapseAcessos" class="menu-item pt-5">
        <!-- begin:CLINIC -->
        <MenuItem :menu="menuClinic.agenda" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
              <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
              <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.calendario" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
              <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
              <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.pep" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M12.025 4.725C9.725 2.425 6.025 2.425 3.725 4.725C1.425 7.025 1.425 10.725 3.725 13.025L11.325 20.625C11.725 21.025 12.325 21.025 12.725 20.625L20.325 13.025C22.625 10.725 22.625 7.025 20.325 4.725C18.025 2.425 14.325 2.425 12.025 4.725Z" fill="currentColor"/>
              <path d="M14.025 17.125H13.925C13.525 17.025 13.125 16.725 13.025 16.325L11.925 11.125L11.025 14.325C10.925 14.725 10.625 15.025 10.225 15.025C9.825 15.125 9.425 14.925 9.225 14.625L7.725 12.325L6.525 12.925C6.425 13.025 6.225 13.025 6.125 13.025H3.125C2.525 13.025 2.125 12.625 2.125 12.025C2.125 11.425 2.525 11.025 3.125 11.025H5.925L7.725 10.125C8.225 9.925 8.725 10.025 9.025 10.425L9.825 11.625L11.225 6.72498C11.325 6.32498 11.725 6.02502 12.225 6.02502C12.725 6.02502 13.025 6.32495 13.125 6.82495L14.525 13.025L15.225 11.525C15.425 11.225 15.725 10.925 16.125 10.925H21.125C21.725 10.925 22.125 11.325 22.125 11.925C22.125 12.525 21.725 12.925 21.125 12.925H16.725L15.025 16.325C14.725 16.925 14.425 17.125 14.025 17.125Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.filaLaudo" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M12.025 4.725C9.725 2.425 6.025 2.425 3.725 4.725C1.425 7.025 1.425 10.725 3.725 13.025L11.325 20.625C11.725 21.025 12.325 21.025 12.725 20.625L20.325 13.025C22.625 10.725 22.625 7.025 20.325 4.725C18.025 2.425 14.325 2.425 12.025 4.725Z" fill="currentColor"/>
              <path d="M14.025 17.125H13.925C13.525 17.025 13.125 16.725 13.025 16.325L11.925 11.125L11.025 14.325C10.925 14.725 10.625 15.025 10.225 15.025C9.825 15.125 9.425 14.925 9.225 14.625L7.725 12.325L6.525 12.925C6.425 13.025 6.225 13.025 6.125 13.025H3.125C2.525 13.025 2.125 12.625 2.125 12.025C2.125 11.425 2.525 11.025 3.125 11.025H5.925L7.725 10.125C8.225 9.925 8.725 10.025 9.025 10.425L9.825 11.625L11.225 6.72498C11.325 6.32498 11.725 6.02502 12.225 6.02502C12.725 6.02502 13.025 6.32495 13.125 6.82495L14.525 13.025L15.225 11.525C15.425 11.225 15.725 10.925 16.125 10.925H21.125C21.725 10.925 22.125 11.325 22.125 11.925C22.125 12.525 21.725 12.925 21.125 12.925H16.725L15.025 16.325C14.725 16.925 14.425 17.125 14.025 17.125Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.cirurgia" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.082 3.08899V3.08301C15.8095 2.3888 16.7764 2.00146 17.782 2.00146C18.7876 2.00146 19.7545 2.3888 20.482 3.08301C21.1967 3.79982 21.5981 4.77072 21.5981 5.78296C21.5981 6.7952 21.1967 7.76622 20.482 8.48303H20.476C20.465 8.47103 20.46 8.45607 20.449 8.44507L19.069 7.06396C19.4099 6.72238 19.6013 6.25954 19.6013 5.77698C19.6013 5.29441 19.4099 4.83157 19.069 4.48999C18.7229 4.15789 18.2617 3.97253 17.782 3.97253C17.3023 3.97253 16.8412 4.15789 16.495 4.48999L15.111 3.10608C15.107 3.10308 15.093 3.09899 15.082 3.08899ZM8.493 20.426L7.10802 19.041C6.76499 19.3758 6.30385 19.562 5.82454 19.5591C5.34523 19.5562 4.88635 19.3645 4.54735 19.0256C4.20835 18.6868 4.01653 18.228 4.01348 17.7487C4.01042 17.2693 4.19638 16.8081 4.53102 16.465L3.14702 15.0801C3.13702 15.0711 3.133 15.057 3.123 15.047H3.11702C2.43672 15.7704 2.06466 16.7302 2.07967 17.7231C2.09468 18.7161 2.49558 19.6642 3.19744 20.3667C3.8993 21.0692 4.84701 21.4709 5.83992 21.4868C6.83283 21.5027 7.79298 21.1317 8.51702 20.452V20.446C8.51602 20.44 8.501 20.436 8.493 20.426Z" fill="currentColor"/>
              <path opacity="0.3" d="M13.674 2.94297C13.8984 2.80434 14.1631 2.74572 14.4251 2.77659C14.6871 2.80745 14.931 2.92602 15.117 3.11301L20.456 8.45298C20.6437 8.63974 20.7625 8.88475 20.7928 9.1478C20.8232 9.41086 20.7633 9.67639 20.623 9.90098C17.9125 14.2288 14.2575 17.8869 9.93202 20.6011C9.70778 20.7384 9.44375 20.7961 9.18263 20.7649C8.92152 20.7337 8.67855 20.6154 8.493 20.4291L3.14702 15.082C2.96012 14.8966 2.84132 14.6534 2.80992 14.3921C2.77852 14.1307 2.83635 13.8663 2.97402 13.6419C3.54335 12.7339 4.14968 11.862 4.79302 11.026C5.04091 10.7072 5.20471 10.3313 5.26936 9.93272C5.33402 9.53414 5.29745 9.12572 5.16301 8.74497C4.97934 8.24025 4.94363 7.69362 5.06008 7.16929C5.17652 6.64496 5.44028 6.16478 5.82033 5.78526C6.20038 5.40573 6.68094 5.14255 7.20543 5.02683C7.72992 4.91111 8.27655 4.94769 8.78102 5.13206C9.16226 5.26657 9.57116 5.30315 9.97023 5.2385C10.3693 5.17385 10.7457 5.00993 11.065 4.76194C11.8997 4.12061 12.7693 3.5143 13.674 2.94297ZM7.85701 15.8L15.835 7.822C15.9305 7.72975 16.0067 7.61942 16.0591 7.49741C16.1115 7.37541 16.1391 7.24421 16.1403 7.11143C16.1414 6.97865 16.1161 6.84699 16.0658 6.7241C16.0156 6.6012 15.9413 6.4895 15.8474 6.39561C15.7535 6.30171 15.6419 6.2275 15.519 6.17722C15.3961 6.12694 15.2644 6.10161 15.1316 6.10276C14.9988 6.10391 14.8676 6.13153 14.7456 6.18394C14.6236 6.23635 14.5133 6.31243 14.421 6.40794L6.44301 14.386C6.3475 14.4782 6.27133 14.5885 6.21892 14.7105C6.16651 14.8326 6.13893 14.9638 6.13777 15.0965C6.13662 15.2293 6.16189 15.3611 6.21217 15.484C6.26246 15.6069 6.33673 15.7185 6.43062 15.8124C6.52451 15.9062 6.63615 15.9806 6.75905 16.0309C6.88195 16.0811 7.01363 16.1064 7.14641 16.1052C7.27919 16.104 7.41042 16.0766 7.53243 16.0241C7.65443 15.9717 7.76476 15.8955 7.85701 15.8ZM10.323 18.484C13.4664 16.194 16.233 13.4274 18.523 10.284C18.6019 10.1778 18.659 10.057 18.691 9.92857C18.7229 9.80015 18.729 9.66666 18.7089 9.53587C18.6889 9.40507 18.6431 9.27957 18.5742 9.1666C18.5053 9.05364 18.4146 8.95546 18.3075 8.87778C18.2004 8.80011 18.0789 8.74448 17.9502 8.71409C17.8214 8.6837 17.6878 8.67919 17.5573 8.70078C17.4267 8.72238 17.3018 8.7697 17.1896 8.83994C17.0775 8.91018 16.9804 9.00193 16.904 9.10996C14.7361 12.084 12.118 14.7021 9.144 16.87C8.97413 16.9947 8.84803 17.17 8.78368 17.3707C8.71933 17.5714 8.72005 17.7873 8.78569 17.9875C8.85134 18.1878 8.97855 18.3622 9.14922 18.4858C9.31988 18.6095 9.52526 18.676 9.73601 18.676C9.94719 18.6765 10.153 18.6092 10.323 18.484ZM8.42302 10.102C8.48302 8.95703 8.98201 8.45904 10.146 8.38804C10.4112 8.37173 10.6591 8.25068 10.8351 8.05161C11.0111 7.85254 11.1008 7.59173 11.0845 7.32651C11.0682 7.0613 10.9472 6.81343 10.7481 6.63743C10.5491 6.46143 10.2882 6.37173 10.023 6.38804C9.54725 6.37933 9.07464 6.46672 8.63347 6.645C8.1923 6.82327 7.79166 7.08873 7.45552 7.42551C7.11939 7.7623 6.85468 8.16344 6.67726 8.60496C6.49985 9.04647 6.41339 9.51924 6.42302 9.99497C6.40941 10.2598 6.50151 10.5191 6.67909 10.716C6.85668 10.9129 7.10521 11.0313 7.37001 11.045H7.42302C7.67882 11.0457 7.92515 10.9483 8.11134 10.7729C8.29754 10.5975 8.40942 10.3574 8.424 10.102H8.42302Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.conta" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M18 21.6C16.3 21.6 15 20.3 15 18.6V2.50001C15 2.20001 14.6 1.99996 14.3 2.19996L13 3.59999L11.7 2.3C11.3 1.9 10.7 1.9 10.3 2.3L9 3.59999L7.70001 2.3C7.30001 1.9 6.69999 1.9 6.29999 2.3L5 3.59999L3.70001 2.3C3.50001 2.1 3 2.20001 3 3.50001V18.6C3 20.3 4.3 21.6 6 21.6H18Z" fill="currentColor"/>
              <path d="M12 12.6H11C10.4 12.6 10 12.2 10 11.6C10 11 10.4 10.6 11 10.6H12C12.6 10.6 13 11 13 11.6C13 12.2 12.6 12.6 12 12.6ZM9 11.6C9 11 8.6 10.6 8 10.6H6C5.4 10.6 5 11 5 11.6C5 12.2 5.4 12.6 6 12.6H8C8.6 12.6 9 12.2 9 11.6ZM9 7.59998C9 6.99998 8.6 6.59998 8 6.59998H6C5.4 6.59998 5 6.99998 5 7.59998C5 8.19998 5.4 8.59998 6 8.59998H8C8.6 8.59998 9 8.19998 9 7.59998ZM13 7.59998C13 6.99998 12.6 6.59998 12 6.59998H11C10.4 6.59998 10 6.99998 10 7.59998C10 8.19998 10.4 8.59998 11 8.59998H12C12.6 8.59998 13 8.19998 13 7.59998ZM13 15.6C13 15 12.6 14.6 12 14.6H10C9.4 14.6 9 15 9 15.6C9 16.2 9.4 16.6 10 16.6H12C12.6 16.6 13 16.2 13 15.6Z" fill="currentColor"/>
              <path d="M15 18.6C15 20.3 16.3 21.6 18 21.6C19.7 21.6 21 20.3 21 18.6V12.5C21 12.2 20.6 12 20.3 12.2L19 13.6L17.7 12.3C17.3 11.9 16.7 11.9 16.3 12.3L15 13.6V18.6Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.solicitacao" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M18.041 22.041C18.5932 22.041 19.041 21.5932 19.041 21.041C19.041 20.4887 18.5932 20.041 18.041 20.041C17.4887 20.041 17.041 20.4887 17.041 21.041C17.041 21.5932 17.4887 22.041 18.041 22.041Z" fill="currentColor"/>
              <path opacity="0.3" d="M6.04095 22.041C6.59324 22.041 7.04095 21.5932 7.04095 21.041C7.04095 20.4887 6.59324 20.041 6.04095 20.041C5.48867 20.041 5.04095 20.4887 5.04095 21.041C5.04095 21.5932 5.48867 22.041 6.04095 22.041Z" fill="currentColor"/>
              <path opacity="0.3" d="M7.04095 16.041L19.1409 15.1409C19.7409 15.1409 20.141 14.7409 20.341 14.1409L21.7409 8.34094C21.9409 7.64094 21.4409 7.04095 20.7409 7.04095H5.44095L7.04095 16.041Z" fill="currentColor"/>
              <path d="M19.041 20.041H5.04096C4.74096 20.041 4.34095 19.841 4.14095 19.541C3.94095 19.241 3.94095 18.841 4.14095 18.541L6.04096 14.841L4.14095 4.64095L2.54096 3.84096C2.04096 3.64096 1.84095 3.04097 2.14095 2.54097C2.34095 2.04097 2.94096 1.84095 3.44096 2.14095L5.44096 3.14095C5.74096 3.24095 5.94096 3.54096 5.94096 3.84096L7.94096 14.841C7.94096 15.041 7.94095 15.241 7.84095 15.441L6.54096 18.041H19.041C19.641 18.041 20.041 18.441 20.041 19.041C20.041 19.641 19.641 20.041 19.041 20.041Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.cobranca" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z" fill="currentColor"/>
              <path d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.gestaoDeRetorno" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z" fill="currentColor"/>
              <path d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.totem" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 16C2 16.6 2.4 17 3 17H21C21.6 17 22 16.6 22 16V15H2V16Z" fill="currentColor"/>
              <path opacity="0.3" d="M21 3H3C2.4 3 2 3.4 2 4V15H22V4C22 3.4 21.6 3 21 3Z" fill="currentColor"/>
              <path opacity="0.3" d="M15 17H9V20H15V17Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.chamadaTV" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 16C2 16.6 2.4 17 3 17H21C21.6 17 22 16.6 22 16V15H2V16Z" fill="currentColor"/>
              <path opacity="0.3" d="M21 3H3C2.4 3 2 3.4 2 4V15H22V4C22 3.4 21.6 3 21 3Z" fill="currentColor"/>
              <path opacity="0.3" d="M15 17H9V20H15V17Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.paciente" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor"/>
              <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.laudo" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="currentColor"/>
              <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor"/>
              <rect x="7" y="12" width="10" height="2" rx="1" fill="currentColor"/>
              <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor"/>
              <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuClinic.todo" v-if="fgSistema == 'CLINIC'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M17 10H11C10.4 10 10 9.6 10 9V8C10 7.4 10.4 7 11 7H17C17.6 7 18 7.4 18 8V9C18 9.6 17.6 10 17 10ZM22 4V3C22 2.4 21.6 2 21 2H11C10.4 2 10 2.4 10 3V4C10 4.6 10.4 5 11 5H21C21.6 5 22 4.6 22 4ZM22 15V14C22 13.4 21.6 13 21 13H11C10.4 13 10 13.4 10 14V15C10 15.6 10.4 16 11 16H21C21.6 16 22 15.6 22 15ZM18 20V19C18 18.4 17.6 18 17 18H11C10.4 18 10 18.4 10 19V20C10 20.6 10.4 21 11 21H17C17.6 21 18 20.6 18 20Z" fill="currentColor"/>
              <path d="M8 5C8 6.7 6.7 8 5 8C3.3 8 2 6.7 2 5C2 3.3 3.3 2 5 2C6.7 2 8 3.3 8 5ZM5 4C4.4 4 4 4.4 4 5C4 5.6 4.4 6 5 6C5.6 6 6 5.6 6 5C6 4.4 5.6 4 5 4ZM8 16C8 17.7 6.7 19 5 19C3.3 19 2 17.7 2 16C2 14.3 3.3 13 5 13C6.7 13 8 14.3 8 16ZM5 15C4.4 15 4 15.4 4 16C4 16.6 4.4 17 5 17C5.6 17 6 16.6 6 16C6 15.4 5.6 15 5 15Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <!-- end:CLINIC -->
        <!-- begin:CASH -->
        <MenuItem :menu="menuCash.fluxoCaixa" v-if="fgSistema == 'CASH'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8" y="9" width="3" height="10" rx="1.5" fill="currentColor"/>
              <rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="currentColor"/>
              <rect x="18" y="11" width="3" height="8" rx="1.5" fill="currentColor"/>
              <rect x="3" y="13" width="3" height="6" rx="1.5" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuCash.pagar" v-if="fgSistema == 'CASH'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="3" y="5" width="18" height="15" rx="3" fill="currentColor" opacity="0.3"/>
              <path d="M12 16V3M8 7l4-4 4 4M7 17h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuCash.receber" v-if="fgSistema == 'CASH'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="3" y="5" width="18" height="15" rx="3" fill="currentColor" opacity="0.3"/>
              <path d="M12 3v13M8 12l4 4 4-4M7 17h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuCash.portadoresMovimentacao" v-if="fgSistema == 'CASH'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"/>
              <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuCash.notasFiscais" v-if="fgSistema == 'CASH'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M18 21.6C16.3 21.6 15 20.3 15 18.6V2.50001C15 2.20001 14.6 1.99996 14.3 2.19996L13 3.59999L11.7 2.3C11.3 1.9 10.7 1.9 10.3 2.3L9 3.59999L7.70001 2.3C7.30001 1.9 6.69999 1.9 6.29999 2.3L5 3.59999L3.70001 2.3C3.50001 2.1 3 2.20001 3 3.50001V18.6C3 20.3 4.3 21.6 6 21.6H18Z" fill="currentColor"/>
              <path d="M12 12.6H11C10.4 12.6 10 12.2 10 11.6C10 11 10.4 10.6 11 10.6H12C12.6 10.6 13 11 13 11.6C13 12.2 12.6 12.6 12 12.6ZM9 11.6C9 11 8.6 10.6 8 10.6H6C5.4 10.6 5 11 5 11.6C5 12.2 5.4 12.6 6 12.6H8C8.6 12.6 9 12.2 9 11.6ZM9 7.59998C9 6.99998 8.6 6.59998 8 6.59998H6C5.4 6.59998 5 6.99998 5 7.59998C5 8.19998 5.4 8.59998 6 8.59998H8C8.6 8.59998 9 8.19998 9 7.59998ZM13 7.59998C13 6.99998 12.6 6.59998 12 6.59998H11C10.4 6.59998 10 6.99998 10 7.59998C10 8.19998 10.4 8.59998 11 8.59998H12C12.6 8.59998 13 8.19998 13 7.59998ZM13 15.6C13 15 12.6 14.6 12 14.6H10C9.4 14.6 9 15 9 15.6C9 16.2 9.4 16.6 10 16.6H12C12.6 16.6 13 16.2 13 15.6Z" fill="currentColor"/>
              <path d="M15 18.6C15 20.3 16.3 21.6 18 21.6C19.7 21.6 21 20.3 21 18.6V12.5C21 12.2 20.6 12 20.3 12.2L19 13.6L17.7 12.3C17.3 11.9 16.7 11.9 16.3 12.3L15 13.6V18.6Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <!-- end:CASH -->
        <!-- begin:BOT -->
        <MenuItem :menu="menuBot.configuracoes" v-if="fgSistema == 'BOT'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
              <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
              <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
            </svg>
          </template>
        </MenuItem>
        <!-- end:BOT -->
         <!-- begin:Analytics -->
        <MenuItem :menu="menuAnalytics.indicadores" v-if="fgSistema == 'ANALYTICS'">
          <template v-slot:icon><svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="13" width="4" height="8" rx="1"/><rect x="10" y="7" width="4" height="14" rx="1" opacity=".65"/><rect x="17" y="3" width="4" height="18" rx="1"/></svg></template>
        </MenuItem>
        <MenuItem :menu="menuAnalytics.relatorios" v-if="fgSistema == 'ANALYTICS'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
              <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
              <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
            </svg>
          </template>
        </MenuItem>
        <!-- end:Analytics -->
        <!-- begin:QUALITY -->
        <MenuItem :menu="menuQuality.sac" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M16 0.200012H4C1.8 0.200012 0 2.00001 0 4.20001V16.2C0 18.4 1.8 20.2 4 20.2H16C18.2 20.2 20 18.4 20 16.2V4.20001C20 2.00001 18.2 0.200012 16 0.200012ZM15 10.2C15 10.9 14.8 11.6 14.6 12.2H18V16.2C18 17.3 17.1 18.2 16 18.2H12V14.8C11.4 15.1 10.7 15.2 10 15.2C9.3 15.2 8.6 15 8 14.8V18.2H4C2.9 18.2 2 17.3 2 16.2V12.2H5.4C5.1 11.6 5 10.9 5 10.2C5 9.50001 5.2 8.80001 5.4 8.20001H2V4.20001C2 3.10001 2.9 2.20001 4 2.20001H8V5.60001C8.6 5.30001 9.3 5.20001 10 5.20001C10.7 5.20001 11.4 5.40001 12 5.60001V2.20001H16C17.1 2.20001 18 3.10001 18 4.20001V8.20001H14.6C14.8 8.80001 15 9.50001 15 10.2Z" fill="currentColor"/>
              <path d="M12 1.40002C15.4 2.20002 18 4.80003 18.8 8.20003H14.6C14.1 7.00003 13.2 6.10003 12 5.60003V1.40002ZM5.40001 8.20003C5.90001 7.00003 6.80001 6.10003 8.00001 5.60003V1.40002C4.60001 2.20002 2.00001 4.80003 1.20001 8.20003H5.40001ZM14.6 12.2C14.1 13.4 13.2 14.3 12 14.8V19C15.4 18.2 18 15.6 18.8 12.2H14.6ZM8.00001 14.8C6.80001 14.3 5.90001 13.4 5.40001 12.2H1.20001C2.00001 15.6 4.60001 18.2 8.00001 19V14.8Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.proposta" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M18 21.6C16.3 21.6 15 20.3 15 18.6V2.50001C15 2.20001 14.6 1.99996 14.3 2.19996L13 3.59999L11.7 2.3C11.3 1.9 10.7 1.9 10.3 2.3L9 3.59999L7.70001 2.3C7.30001 1.9 6.69999 1.9 6.29999 2.3L5 3.59999L3.70001 2.3C3.50001 2.1 3 2.20001 3 3.50001V18.6C3 20.3 4.3 21.6 6 21.6H18Z" fill="currentColor"/>
              <path d="M12 12.6H11C10.4 12.6 10 12.2 10 11.6C10 11 10.4 10.6 11 10.6H12C12.6 10.6 13 11 13 11.6C13 12.2 12.6 12.6 12 12.6ZM9 11.6C9 11 8.6 10.6 8 10.6H6C5.4 10.6 5 11 5 11.6C5 12.2 5.4 12.6 6 12.6H8C8.6 12.6 9 12.2 9 11.6ZM9 7.59998C9 6.99998 8.6 6.59998 8 6.59998H6C5.4 6.59998 5 6.99998 5 7.59998C5 8.19998 5.4 8.59998 6 8.59998H8C8.6 8.59998 9 8.19998 9 7.59998ZM13 7.59998C13 6.99998 12.6 6.59998 12 6.59998H11C10.4 6.59998 10 6.99998 10 7.59998C10 8.19998 10.4 8.59998 11 8.59998H12C12.6 8.59998 13 8.19998 13 7.59998ZM13 15.6C13 15 12.6 14.6 12 14.6H10C9.4 14.6 9 15 9 15.6C9 16.2 9.4 16.6 10 16.6H12C12.6 16.6 13 16.2 13 15.6Z" fill="currentColor"/>
              <path d="M15 18.6C15 20.3 16.3 21.6 18 21.6C19.7 21.6 21 20.3 21 18.6V12.5C21 12.2 20.6 12 20.3 12.2L19 13.6L17.7 12.3C17.3 11.9 16.7 11.9 16.3 12.3L15 13.6V18.6Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.agendaVisita" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
              <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
              <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.tarefas" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M5.78001 21.115L3.28001 21.949C3.10897 22.0059 2.92548 22.0141 2.75004 21.9727C2.57461 21.9312 2.41416 21.8418 2.28669 21.7144C2.15923 21.5869 2.06975 21.4264 2.0283 21.251C1.98685 21.0755 1.99507 20.892 2.05201 20.7209L2.886 18.2209L7.22801 13.879L10.128 16.774L5.78001 21.115Z" fill="currentColor"/>
              <path d="M21.7 8.08899L15.911 2.30005C15.8161 2.2049 15.7033 2.12939 15.5792 2.07788C15.455 2.02637 15.3219 1.99988 15.1875 1.99988C15.0531 1.99988 14.92 2.02637 14.7958 2.07788C14.6717 2.12939 14.5589 2.2049 14.464 2.30005L13.74 3.02295C13.548 3.21498 13.4402 3.4754 13.4402 3.74695C13.4402 4.01849 13.548 4.27892 13.74 4.47095L14.464 5.19397L11.303 8.35498C10.1615 7.80702 8.87825 7.62639 7.62985 7.83789C6.38145 8.04939 5.2293 8.64265 4.332 9.53601C4.14026 9.72817 4.03256 9.98855 4.03256 10.26C4.03256 10.5315 4.14026 10.7918 4.332 10.984L13.016 19.667C13.208 19.859 13.4684 19.9668 13.74 19.9668C14.0115 19.9668 14.272 19.859 14.464 19.667C15.3575 18.77 15.9509 17.618 16.1624 16.3698C16.374 15.1215 16.1932 13.8383 15.645 12.697L18.806 9.53601L19.529 10.26C19.721 10.452 19.9814 10.5598 20.253 10.5598C20.5245 10.5598 20.785 10.452 20.977 10.26L21.7 9.53601C21.7952 9.44108 21.8706 9.32825 21.9221 9.2041C21.9737 9.07995 22.0002 8.94691 22.0002 8.8125C22.0002 8.67809 21.9737 8.54505 21.9221 8.4209C21.8706 8.29675 21.7952 8.18392 21.7 8.08899Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.vozChamada" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M14 3V20H2V3C2 2.4 2.4 2 3 2H13C13.6 2 14 2.4 14 3ZM11 13V11C11 9.7 10.2 8.59995 9 8.19995V7C9 6.4 8.6 6 8 6C7.4 6 7 6.4 7 7V8.19995C5.8 8.59995 5 9.7 5 11V13C5 13.6 4.6 14 4 14V15C4 15.6 4.4 16 5 16H11C11.6 16 12 15.6 12 15V14C11.4 14 11 13.6 11 13Z" fill="currentColor"/>
              <path d="M2 20H14V21C14 21.6 13.6 22 13 22H3C2.4 22 2 21.6 2 21V20ZM9 3V2H7V3C7 3.6 7.4 4 8 4C8.6 4 9 3.6 9 3ZM6.5 16C6.5 16.8 7.2 17.5 8 17.5C8.8 17.5 9.5 16.8 9.5 16H6.5ZM21.7 12C21.7 11.4 21.3 11 20.7 11H17.6C17 11 16.6 11.4 16.6 12C16.6 12.6 17 13 17.6 13H20.7C21.2 13 21.7 12.6 21.7 12ZM17 8C16.6 8 16.2 7.80002 16.1 7.40002C15.9 6.90002 16.1 6.29998 16.6 6.09998L19.1 5C19.6 4.8 20.2 5 20.4 5.5C20.6 6 20.4 6.60005 19.9 6.80005L17.4 7.90002C17.3 8.00002 17.1 8 17 8ZM19.5 19.1C19.4 19.1 19.2 19.1 19.1 19L16.6 17.9C16.1 17.7 15.9 17.1 16.1 16.6C16.3 16.1 16.9 15.9 17.4 16.1L19.9 17.2C20.4 17.4 20.6 18 20.4 18.5C20.2 18.9 19.9 19.1 19.5 19.1Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.vozRecebida" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M14 3V20H2V3C2 2.4 2.4 2 3 2H13C13.6 2 14 2.4 14 3ZM11 13V11C11 9.7 10.2 8.59995 9 8.19995V7C9 6.4 8.6 6 8 6C7.4 6 7 6.4 7 7V8.19995C5.8 8.59995 5 9.7 5 11V13C5 13.6 4.6 14 4 14V15C4 15.6 4.4 16 5 16H11C11.6 16 12 15.6 12 15V14C11.4 14 11 13.6 11 13Z" fill="currentColor"/>
              <path d="M2 20H14V21C14 21.6 13.6 22 13 22H3C2.4 22 2 21.6 2 21V20ZM9 3V2H7V3C7 3.6 7.4 4 8 4C8.6 4 9 3.6 9 3ZM6.5 16C6.5 16.8 7.2 17.5 8 17.5C8.8 17.5 9.5 16.8 9.5 16H6.5ZM21.7 12C21.7 11.4 21.3 11 20.7 11H17.6C17 11 16.6 11.4 16.6 12C16.6 12.6 17 13 17.6 13H20.7C21.2 13 21.7 12.6 21.7 12ZM17 8C16.6 8 16.2 7.80002 16.1 7.40002C15.9 6.90002 16.1 6.29998 16.6 6.09998L19.1 5C19.6 4.8 20.2 5 20.4 5.5C20.6 6 20.4 6.60005 19.9 6.80005L17.4 7.90002C17.3 8.00002 17.1 8 17 8ZM19.5 19.1C19.4 19.1 19.2 19.1 19.1 19L16.6 17.9C16.1 17.7 15.9 17.1 16.1 16.6C16.3 16.1 16.9 15.9 17.4 16.1L19.9 17.2C20.4 17.4 20.6 18 20.4 18.5C20.2 18.9 19.9 19.1 19.5 19.1Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <MenuItem :menu="menuQuality.projetos" v-if="fgSistema == 'QUALITY'">
          <template v-slot:icon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.3" d="M17 10H11C10.4 10 10 9.6 10 9V8C10 7.4 10.4 7 11 7H17C17.6 7 18 7.4 18 8V9C18 9.6 17.6 10 17 10ZM22 4V3C22 2.4 21.6 2 21 2H11C10.4 2 10 2.4 10 3V4C10 4.6 10.4 5 11 5H21C21.6 5 22 4.6 22 4ZM22 15V14C22 13.4 21.6 13 21 13H11C10.4 13 10 13.4 10 14V15C10 15.6 10.4 16 11 16H21C21.6 16 22 15.6 22 15ZM18 20V19C18 18.4 17.6 18 17 18H11C10.4 18 10 18.4 10 19V20C10 20.6 10.4 21 11 21H17C17.6 21 18 20.6 18 20Z" fill="currentColor"/>
              <path d="M8 5C8 6.7 6.7 8 5 8C3.3 8 2 6.7 2 5C2 3.3 3.3 2 5 2C6.7 2 8 3.3 8 5ZM5 4C4.4 4 4 4.4 4 5C4 5.6 4.4 6 5 6C5.6 6 6 5.6 6 5C6 4.4 5.6 4 5 4ZM8 16C8 17.7 6.7 19 5 19C3.3 19 2 17.7 2 16C2 14.3 3.3 13 5 13C6.7 13 8 14.3 8 16ZM5 15C4.4 15 4 15.4 4 16C4 16.6 4.4 17 5 17C5.6 17 6 16.6 6 16C6 15.4 5.6 15 5 15Z" fill="currentColor"/>
            </svg>
          </template>
        </MenuItem>
        <!-- end:QUALITY -->
      </div>
    </transition>
    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">Menu</span>
      </div>
    </div>
    <!-- begin:CLINIC -->
    <MenuItem :menu="menuClinic.sistema" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L15.2929 5.29289C15.6834 5.68342 15.6834 6.31658 15.2929 6.70711L12.7071 9.29289C12.3166 9.68342 11.6834 9.68342 11.2929 9.29289L8.70711 6.70711C8.31658 6.31658 8.31658 5.68342 8.70711 5.29289L11.2929 2.70711Z" fill="currentColor" />
          <path d="M11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15.2929 17.2929C15.6834 17.6834 15.6834 18.3166 15.2929 18.7071L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L8.70711 18.7071C8.31658 18.3166 8.31658 17.6834 8.70711 17.2929L11.2929 14.7071Z" fill="currentColor" />
          <path opacity="0.3" d="M5.29289 8.70711C5.68342 8.31658 6.31658 8.31658 6.70711 8.70711L9.29289 11.2929C9.68342 11.6834 9.68342 12.3166 9.29289 12.7071L6.70711 15.2929C6.31658 15.6834 5.68342 15.6834 5.29289 15.2929L2.70711 12.7071C2.31658 12.3166 2.31658 11.6834 2.70711 11.2929L5.29289 8.70711Z" fill="currentColor" />
          <path opacity="0.3" d="M17.2929 8.70711C17.6834 8.31658 18.3166 8.31658 18.7071 8.70711L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L18.7071 15.2929C18.3166 15.6834 17.6834 15.6834 17.2929 15.2929L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17.2929 8.70711Z" fill="currentColor" />
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuClinic.cadastros" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuClinic.atendimentos" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
          <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuClinic.relatorios" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuClinic.ferramentas" v-if="fgSistema == 'CLINIC'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:CLINIC -->
    <!-- begin:CASH -->
    <MenuItem :menu="menuCash.cadastros" v-if="fgSistema == 'CASH'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuCash.relatorios" v-if="fgSistema == 'CASH'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="currentColor"/>
          <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor"/>
          <rect x="7" y="12" width="10" height="2" rx="1" fill="currentColor"/>
          <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor"/>
          <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuCash.payLogos" v-if="fgSistema == 'CASH'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z" fill="currentColor"/>
          <path d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:CASH -->
    <!-- begin:QUALITY -->
    <MenuItem :menu="menuQuality.sistema" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L15.2929 5.29289C15.6834 5.68342 15.6834 6.31658 15.2929 6.70711L12.7071 9.29289C12.3166 9.68342 11.6834 9.68342 11.2929 9.29289L8.70711 6.70711C8.31658 6.31658 8.31658 5.68342 8.70711 5.29289L11.2929 2.70711Z" fill="currentColor" />
          <path d="M11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15.2929 17.2929C15.6834 17.6834 15.6834 18.3166 15.2929 18.7071L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L8.70711 18.7071C8.31658 18.3166 8.31658 17.6834 8.70711 17.2929L11.2929 14.7071Z" fill="currentColor" />
          <path opacity="0.3" d="M5.29289 8.70711C5.68342 8.31658 6.31658 8.31658 6.70711 8.70711L9.29289 11.2929C9.68342 11.6834 9.68342 12.3166 9.29289 12.7071L6.70711 15.2929C6.31658 15.6834 5.68342 15.6834 5.29289 15.2929L2.70711 12.7071C2.31658 12.3166 2.31658 11.6834 2.70711 11.2929L5.29289 8.70711Z" fill="currentColor" />
          <path opacity="0.3" d="M17.2929 8.70711C17.6834 8.31658 18.3166 8.31658 18.7071 8.70711L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L18.7071 15.2929C18.3166 15.6834 17.6834 15.6834 17.2929 15.2929L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17.2929 8.70711Z" fill="currentColor" />
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.cadastros" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.agendas" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor" />
          <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor" />
          <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor" />
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.atendimentos" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"/>
          <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.comercial" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
          <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.ferramentas" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M22.0318 8.59998C22.0318 10.4 21.4318 12.2 20.0318 13.5C18.4318 15.1 16.3318 15.7 14.2318 15.4C13.3318 15.3 12.3318 15.6 11.7318 16.3L6.93177 21.1C5.73177 22.3 3.83179 22.2 2.73179 21C1.63179 19.8 1.83177 18 2.93177 16.9L7.53178 12.3C8.23178 11.6 8.53177 10.7 8.43177 9.80005C8.13177 7.80005 8.73176 5.6 10.3318 4C11.7318 2.6 13.5318 2 15.2318 2C16.1318 2 16.6318 3.20005 15.9318 3.80005L13.0318 6.70007C12.5318 7.20007 12.4318 7.9 12.7318 8.5C13.3318 9.7 14.2318 10.6001 15.4318 11.2001C16.0318 11.5001 16.7318 11.3 17.2318 10.9L20.1318 8C20.8318 7.2 22.0318 7.59998 22.0318 8.59998Z" fill="currentColor"/>
          <path d="M4.23179 19.7C3.83179 19.3 3.83179 18.7 4.23179 18.3L9.73179 12.8C10.1318 12.4 10.7318 12.4 11.1318 12.8C11.5318 13.2 11.5318 13.8 11.1318 14.2L5.63179 19.7C5.23179 20.1 4.53179 20.1 4.23179 19.7Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuQuality.ajuda" v-if="fgSistema == 'QUALITY'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M9.10001 7.00005L6.2 12H2C2 8.30005 4 5.10005 7 3.30005L9.10001 7.00005ZM17 3.30005L14.9 7.00005L17.8 12H22C22 8.30005 20 5.10005 17 3.30005ZM14.9 17H9.10001L7 20.7C8.5 21.6 10.2 22 12 22C13.8 22 15.5 21.5 17 20.7L14.9 17Z" fill="currentColor"/>
          <path d="M17 3.3L14.9 7H9.10001L7 3.3C8.5 2.5 10.2 2 12 2C13.8 2 15.5 2.5 17 3.3ZM17.8 12L14.9 17L17 20.7C20 19 22 15.7 22 12H17.8ZM6.2 12H2C2 15.7 4 18.9 7 20.7L9.10001 17L6.2 12Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:QUALITY -->
    <!-- begin:BOT -->
    <MenuItem :menu="menuBot.cadastros" v-if="fgSistema == 'BOT'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuBot.recargaIA" v-if="fgSistema === 'BOT' && String(idEmitenteML) === '665'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="3" fill="currentColor" opacity="0.3"/><path d="M12 8V16M8 12H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </template>
    </MenuItem>
    <MenuItem :menu="menuBot.relatorios" v-if="fgSistema == 'BOT'">
      <template v-slot:icon>
        <i class="ki-duotone ki-chart-simple fs-2">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
        </i>
      </template>
    </MenuItem>
    <!-- end:BOT -->
     <!-- begin:ANALYTICS -->
    <MenuItem :menu="menuAnalytics.relatorios" v-if="fgSistema == 'ANALYTICS'">
      <template v-slot:icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
          <path d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z" fill="currentColor"/>
        </svg>
      </template>
    </MenuItem>
    <!-- end:ANALYTICS -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { carregadorIndicadores } from "@/core/services/indicadores-analytics";
const acessosIndicadores = new WeakMap();

import MenuItem from "@/../../desk-spirit/src/components/general/menus/MenuItem";

export default {
  name: "MenuLeft",
  components: {
    MenuItem
  },
  props: ["buscaMenus"],
  data() {
    return {
      indicadoresPermitido: false,
      permissoesAtivas: [
        "CLM",
        "CLMATAM",
        "CLMCAUN",
        "CLMCAPA",
        "CLMCAME",
        "CLMCACO",
        "CLMCASE",
        "CLMCAPC",
        "CLMCACE",
        "CLMCAPD",
        "CLMTAP",
        "CLMTACP",
        "CLMTAUP",
        "CLMTAMA",
        "CLMATT",
        "CLMATTP",
        "CLMATTF",
        "CLMATFT",
        "CLMATAT",
        "CLMATCP",
        "CLMCA",
        "CLMTA",
        "CLMTATE",
        "CLMTACT",
        "CLMTALO",
        "CLMTALC",
        "CLMTAC",
        "CLMTAMC",
        "CLMTATU",
        "CLMTATX",
        "CLMTATP",
        "CLMTATG",
        "CLMRE", 
        "CLMREAG", 
        "CLMREAGSE", 
        "CLMREADRM", 
        "CLMATRT", 
        "CLMATSO",
        "CLMATOR",
        "CLMTAMD", 
        "CLMTAES",
        "CLMTAAU",
        "CLMTAF",
        "CLMTACG",
        "CLMTACA",
        "CLMTACR",
        "CLMTAPC",
        "CLMTAPF",
        "CLMTATO",
        "CLMTAD",
        "CLMTAFE",
        "CLMAT",
        "CLMATFA",
        "CLMATCV",

        "CSM", 
        "CSMMOFL", 
        "CSMEMNF",
        "CSMMOCC", 
        "CSMCA", 
        "CSMCAEM",
        "CSMCAEP",
        "CSMCAPO",
        "CSMTA",
        "CSMTAEM",
        "CSMTAEMCE",
        "CSMCAPF",
        "CSMCAPJ",
        "CSMCATP",
        "CSMCAPR",
        "CSMTAEMPR",
        "CSMTAFI",
        "CSMTAFICR",
        "CSMTAEMTO",
        "CSMTAPR",
        "CSMTAPRCP",
        "CSMRE",
        "CSMREFL",
        "CSMREFLDR",
        "CSMTAFINO",
        "CSMTAFITM",
        "CSMTAFIMO",
        "CSMTAFE",
        "BOT",
        "BOTCO",
        "BOTCA",
        "ANM",
        "ANMRE"
      ],
      permissoes: [],
      menuClinic: {
        dashboard: {
          title: "Dashboard",
          name: "dashboard",
          permissao: "CLM",
          acessar: "dashboard"
        },
        favoritos: {
          title: "Favoritos",
          name: "favoritos",
          permissao: "CLM",
          submenu: []
        },
        agenda: {
          title: "Agenda",
          name: "agenda",
          permissao: "CLMATAM",
          acessar: "agenda"
        },
        calendario: {
          title: "Calendário",
          name: "agendaGoogle",
          permissao: "CLMATAM",
          acessar: "agendaGoogle"
        },
        pep: {
          title: "Prontuário - PEP Icons",
          name: "filaPep",
          permissao: "CLMATAT",
          acessar: "filaPep"
        },
        filaLaudo: {
          title: "Fila de Laudos",
          name: "filaLaudo",
          permissao: "CLMATAT",
          acessar: "filaLaudo"
        },
        cirurgia: {
          title: "Cirurgia",
          name: "cirurgia"
        },
        conta: {
          title: "Contas de Pacientes",
          name: "contasPaciente",
          acessar: "contasPaciente",
          permissao: "CLMATCP"
        },
        solicitacao: {
          title: "Solicitação",
          name: "solicitacao"
        },
        cobranca: {
          title: "Cobrança",
          name: "cobrancasConvenio",
          acessar: "cobrancasConvenio",
          permissao: "CLMATCV"
        },
        gestaoDeRetorno: {
          title: "Gestão de Retorno",
          name: "gestaoDeRetorno",
          acessar: "gestaoDeRetorno",
          permissao: "CLMATRT"
        },
        totem: {
          title: "Totem", 
          name: "totem", 
          permissao: "CLMATFT", 
          submenu: [{
            title: "Totem Funcionário", 
            name: "totemFuncionario", 
            permissao: "CLMATFT", 
            acessar: "totemFuncionario"
          }, {
            title: "Totem Paciente", 
            name: "totemPaciente", 
            permissao: "CLMATFT", 
            acessar: "totemPaciente"
          }]
        },
        chamadaTV: {
          title: "Chamada TV",
          name: "chamadaTV",
          permissao: "CLMATT",
          acessar: "chamadaNaTV"
        },
        paciente: {
          title: "Paciente",
          name: "paciente"
        },
        laudo: {
          title: "Laudo",
          name: "laudo"
        },
        todo: {
          title: "To Do",
          name: "todo"
        },
        sistema: {
          title: "Sistema",
          name: "sistema",
          submenu: [{
            title: "Utilitários",
            name: "utilitarios",
            submenu: [{
              title: "Mensagens Linha Master",
              name: "mensagensLinhaMaster",
              separator: true
            },{
              title: "Captura Imagem Automático",
              name: "capturaImagemAutomatico"
            },{
              title: "Avisa Entrada de Paciente",
              name: "avisaEntradaPaciente",
              separator: true
            },{
              title: "Log de Usuários Avançado",
              name: "logUsuariosAvancado"
            },{
              title: "Log de Usuários",
              name: "logUsuarios"
            },{
              title: "Ponto Eletrônico",
              name: "pontoEletronico"
            }]
          }]
        },
        cadastros: {
          title: "Cadastros",
          name: "cadastros",
          permissao: "CLMCA",
          submenu: [{
            title: "Unidades",
            name: "unidades",
            acessar: "unidades",
            permissao: "CLMCAUN"
          },{
            title: "Pacientes",
            name: "pacientes",
            acessar: "pacientes",
            permissao: "CLMCAPA",
            bold: true
          },{
            title: "Staff Médico",
            name: "staffMedicos",
            acessar: "staffMedicos",
            permissao: "CLMCAME"
          },{
            title: "Convênios / Planos de Saúde",
            name: "convenios",
            acessar: "convenios",
            permissao: "CLMCACO"
          },{
            title: "Procedimentos",
            name: "procedimentos",
            acessar: "procedimentos",
            permissao: "CLMCAPC",
            bold: true
          },{
            title: "Produtos",
            name: "produtos",
            acessar: "produtos",
            permissao: "CLMCAPD"
          },{
            title: "Serviços",
            name: "servicos",
            acessar: "servicos",
            permissao: "CLMCASE"
          },{
            title: "Contatos Externos",
            name: "contatosExternos",
            acessar: "contatosExternos",
            separator: true,
            permissao: "CLMCACE"
          },{
            title: "Tabelas",
            name: "tabelas",
            permissao: "CLMTA",
            submenu: [{
              title: "Atendimento",
              name: "atendimento",
              permissao: "CLMTA",
              submenu: [{
                title: "Categorias de Locais de Atendimento",
                name: "categoriasLocaisAtendimento",
                acessar: "locaisAtendimentoCategorias",
                permissao: "CLMTALC"
              },{
                title: "Locais de Atendimento",
                name: "locais",
                acessar: "locais",
                permissao: "CLMTALO"
              },{
                title: "Protocolos de Tratamento",
                name: "protocolosTratamento"
              },{
                title: "Sessões",
                name: "sessoes",
                submenu: [{
                  title: "Aparelhos",
                  name: "aparelhos"
                },{
                  title: "Lados",
                  name: "lados"
                },{
                  title: "Regiões",
                  name: "regioes"
                }]
              },{
                title: "Status dos Locais",
                name: "statusLocais",
                separator: true
              },{
                title: "Equipes Médicas",
                name: "equipesMedicas"
              },{
                title: "Especialidades",
                name: "especialidades",
                acessar: "especialidades",
                permissao: "CLMTAES",
              },{
                title: "IBGE Localidade",
                name: "ibgeLocalidade"
              },{
                title: "Representantes",
                name: "representantes"
              },{
                title: "Motivos (Ausência, Canc, Desist, Emerg, Bloqueio)",
                name: "motivos",
                acessar: "motivosAusencia",
                permissao: "CLMTAAU",
                separator: true
              },{
                title: "CID - 10", 
                name: "cid", 
              },{
                title: "Medicamentos Personalizados", 
                name: "medicamentosPersonalizados", 
                acessar: "medicamentosPersonalizados", 
                permissao: "CLMTAMD"
              },{
                title: "Medicamentos - Posologias", 
                name: "medicamentosPosologias", 
                acessar: "medicamentosPosologias", 
                permissao: "CLMTAMD"
              },{
                title: "Medicamentos - Substitutos",
                name: "medicamentosSubstitutos",
                acessar: "medicamentosSubstitutos",
                permissao: "CLMTAMD",
                separator: true                
              },{
                title: "Categorias de Modelos de Texto do PEP",
                name: "categoriasTextos",
                permissao: "CLMTACT", 
                acessar: "categoriasTextos"
              },{
                title: "Modelos de Texto do PEP",
                name: "textos",
                permissao: "CLMTATE", 
                acessar: "textos",
              },{
                title: "Modelos de email",
                name: "textosEmail",
                permissao: "XXXXXXX", 
                acessar: "textosEmail",
                separator: true,
              },{
                title: "Ficha de dados",
                name: "fichaDados",
                submenu: [{
                  title: "Grupo de Limites",
                  name: "grupoLimites"
                },{
                  title: "Limites",
                  name: "limites"
                },{
                  title: "Campos",
                  name: "campos"
                },{
                  title: "Arquétipos",
                  name: "arquetipos"
                }]
              }]
            },{
              title: "Faturamento",
              name: "faturamento",
              permissao: "CLMTAF",
              submenu: [{
                title: "Centros de Responsabilidade",
                name: "centrosResponsabilidade",
                acessar: "centrosResponsabilidade",
                permissao: "CLMTACR"
              },{
                title: "Tipos de Pendência",
                name: "tiposPendencia",
                acessar: "tiposPendencia",
                permissao: "CLMTATP"
              },{
                title: "Tipos de Glosas",
                name: "tiposGlosa",
                acessar: "tiposGlosa",
                permissao: "CLMTATG"
              },{
                title: "Turnos",
                name: "turnos",
                acessar: "turnos",
                permissao: "CLMTATU"
              },{
                title: "Taxas de Turno",
                name: "taxasTurno",
                acessar: "taxasTurno",
                permissao: "CLMTATX",
                separator: true
              },{
                title: "Classificação de Guias",
                name: "classificacaoGuias",
                acessar: "classificacaoGuias",
                permissao: "CLMTACG"
              },{
                title: "Classificação de Atendimentos",
                name: "classificacaoAtendimentos",
                acessar: "classificacaoAtendimentos",
                permissao: "CLMTACA",
                separator: true
              },{
                title: "Configuração para Faturamento Automático",
                name: "configuracaoFaturamentoAutomatico"
              },{
                title: "Layouts de Convênios",
                name: "layoutsConvenios"
              }]
            },{
              title: "Comissionamento",
              name: "comissionamento", 
              permissao: "CLMTAC",
              separator: true,
              submenu: [{
                title: "Categorias do Staff Médico",
                name: "categoriasStaffMedico",
                acessar: "staffMedicosCategorias",
                permissao: "CLMTAMC"
              },{
                title: "Donos de Equipamentos",
                name: "donosEquipamentos"
              },{
                title: "Tipos de Comissão",
                name: "tiposComissao",
                bold: true
              }]
            },{
              title: "Produtos / Serviços",
              name: "produtosServicos",
              permissao: "CLMTAP",
              separator: true,
              submenu: [{
                title: "Categorias de Produtos / Serviços",
                name: "categoriasProdutosServicos",
                acessar: "produtosCategorias",
                permissao: "CLMTACP"

              },{
                title: "Unidades de Produtos",
                name: "unidadesProdutos",
                acessar: "produtosUnidades",
                permissao: "CLMTAUP"
              },{
                title: "Marcas",
                name: "marcas",
                acessar: "produtosMarcas",
                permissao: "CLMTAMA"
              },{
                title: "Tempo de Duração Atendimento",
                name: "tempoDuracaoAtendimento",
                separator: true
              },{
                title: "Brasíndice",
                name: "brasindice"
              },{
                title: "Preços",
                name: "tabelasPrecos",
                acessar: "tabelasPrecos",
                permissao: "CLMTAPC",
                bold: true
              }]
            },{
              title: "Prescrição",
              name: "prescricao",
              submenu: [{
                title: "Formas de Aplicação",
                name: "formasAplicacao",
                bold: true
              },{
                title: "Intervalos de Aplicação",
                name: "intervalosAplicacao"
              }]
            },{
              title: "Laudo",
              name: "laudo",
              separator: true,
              submenu: [{
                title: "Títulos de Laudo",
                name: "titulosLaudo",
                bold: true
              },{
                title: "Frases de Laudo",
                name: "frasesLaudo"
              }]
            },{
              title: "Pacientes",
              name: "pacientes",
              permissao: "CLMTAP",
              separator: true,
              submenu: [{
                title: "Empresas",
                name: "empresas",
                bold: true
              },{
                title: "Portadores",
                name: "portadores",
              },{
                title: "Profissões",
                name: "profissoes",
                acessar: "profissoes",
                permissao: "CLMTAPF"
              },{
                title: "CEP",
                name: "cep",
                separator: true
              },{
                title: "Acompanhantes",
                name: "acompanhantes"
              },{
                title: "Tipos de Ocorrência",
                name: "tiposOcorrencia",
                acessar: "tiposOcorrencias",
                permissao: "CLMTATO"
              }]
            },{
              title: "Diversos",
              name: "diversos",
              permissao: "CLMTAD",
              separator: true,
              submenu: [{
                title: "Feriados",
                name: "feriados",
                acessar: "feriados",
                permissao: "CLMTAFE"
              }],
            },{
              title: "Facilitadores",
              name: "facilitadores"
            }]
          }]
        },
        atendimentos: {
          title: "Atendimentos",
          name: "atendimentos", 
          permissao: "CLMAT",
          submenu: [{
            title: "Agendas",
            name: "agendas", 
            permissao: "CLMAT",
            bold: true,
            separator: true,
            submenu: [{
              title: "Ambulatório",
              name: "ambulatorio"
            },{
              title: "Cirurgia",
              name: "cirurgia",
              separator: true
            },{
              title: "Gestão de Retorno",
              name: "gestaoDeRetorno", 
              permissao: "CLMATRT", 
              acessar: "gestaoDeRetorno"
            },{
              title: "Fila do Totem",
              name: "filaTotem",
              separator: true
            },{
              title: "Ocupação",
              name: "ocupacao"
            }]
          },{
            title: "Atendimento",
            name: "atendimento",
            permissao: "CLMAT", 
            submenu: [{
              title: "Atendimento",
              name: "atendimento"
            },{
              title: "Centro Cirúrgico",
              name: "centroCirurgico",
              bold: true
            },{
              title: "Inform. Médicas Pendentes",
              name: "informMedicasPendentes"
            },{
              title: "Laudo Web",
              name: "laudoWeb"
            },{
              title: "Solicitações Procedimentos",
              name: "solicitacaoProcedimento", 
              permissao: "CLMATSO", 
              acessar: "solicitacaoProcedimento"
            },{
              title: "Orçamentos de Pacientes",
              name: "orcamentoPaciente", 
              permissao: "CLMATOR", 
              acessar: "orcamentoPaciente"
            }]
          },{
            title: "Faturamento",
            name: "faturamento",
            permissao: "CLMATCP",
            submenu: [{
              title: "Faturamento",
              name: "faturamento"
            },{
              title: "Contas de Pacientes",
              name: "contasPaciente",
              acessar: "contasPaciente",
              permissao: "CLMATCP"
            },{
              title: "Pendências",
              name: "pendencias",
              permissao: "CLMATPP"
            },{
              title: "Lançamentos Extras para Repasse",
              name: "lançamentosExtrasParaRepasse",
              permissao: "CLMATEX"
            },{
              title: "Cobranças",
              name: "cobrancas",
              permissao: "CLMATCV",
              separator: true,
              submenu: [{
                title: "Cobranças de Convênios",
                name: "cobrancasConvenio",
                acessar: "cobrancasConvenio",
                permissao: "CLMATCV"
              },{
                title: "Justificativas de Glosas Técnicas",
                name: "justificativasDeGlosasTecnicas",
                permissao: "CLMATGT"
              },{
                title: "Acompanhamento",
                name: "acompanhamento",
                permissao: "CLMATGL",
            }]},{
              title: "Repasse",
              name: "repasse",
              permissao: "CLMREADRM",
              acessar: "repasse", 
              separator: true
            },{
              title: "Dmed (Relação p/declaração de serviços médicos)",
              name: "dmed",
              permissao: "CLMATDM"
            },{
              title: "CIHA (Relação p/ declaração junto ao SUS)",
              name: "ciha",
              permissao: "CLMATSU"
            }]
          },{
            title: "Solicitações",
            name: "solicitacoes",
            submenu: [{
              title: "Requisição/Devolução Internados",
              name: "requisicaodevolucaoInternados",
              permissao: "CLMATIR"
            },{
              title: "Prescrição Médica Internados",
              name: "prescricaoMedicaInternados",
              permissao: "CLMATPR"
            },{
              title: "Procedimentos Realizados em Internados",
              name: "procedimentosRealizadosEmInternados",
              permissao: "CLMATEX",
              separator: true,
            },{
              title: "Requisição/Devolução Ambulatório",
              name: "requisicaoDevolucaoAmbulatorio",
              permissao: "CLMATAR"
            },{
              title: "Prescrição Médica Ambulatório",
              name: "prescricaoMedicaAmbulatorio",
              permissao: "CLMATAP",
              separator: true,
            },{
              title: "Requisições Encerradas",
              name: "requisicoesEncerradas",
              permissao: "CLMATRE",
              separator: true,
            },{
              title: "Requisição/Devolução Consumo de Setor",
              name: "requisicooDevolucaoConsumoDeSetor",
              permissao: "CLMATCS"
            }]
          }]
        },
        relatorios:{
          title: "Relatórios",
          name: "Relatorios",
          permissao: "CLMRE",
          submenu: [{
            title: "Agenda",
            name: "agendaRelatorios",
            permissao: "CLMREAG",
            submenu: [{
              title: "Agendamentos por &Planos de Saúde",
              name: "agendamentosPorPlanosDeSaude",
              permissao: "CLMREAGCO"
            },{
              title: "Agendamentos &WEB",
              name: "agendamentosWeb",
              permissao: "CLMREAGWE",
            },{
              title: "Agenda por Médico",
              name: "agendaPorMedico",
              permissao: "CLMREAGWE",
            },{
              title: "Agenda por Local",
              name: "agendaPorLocal",
              permissao: "CLMREAGLO",
              separator: true,
            },{
              title: "Faltas por Paciente",
              name: "faltasPorPaciente",
              permissao: "CLMREAGFA",
            },{
              title: "Pacotes de Sessão",
              name: "relatorioPacoteSessoes",
              acessar: "relatorioPacoteSessoes",
              permissao: "CLMREAGSE",
            }]
          },{
            title: "Internação",
            name: "internacao",
            permissao: "CLMREIN",
            submenu: [{
              title: "&Censo Diário",
              name: "censoDiario",
              permissao: "CLMREINCE",
            },{
              title: "Estatística de Tipo de Acomodação",
              name: "estatísticaDeTipoDeAcomodacao",
              permissao: "CLMREINTO",
            }]
          },{
            title: "Atendimentos",
            name: "atendimentosRelatorios",
            permissao: "CLMREAT",
            submenu: [{
              title: "Cruzamento de Dados do &Atendimento",
              name: "cruzamentoDeDadosDoAtendimento",
              permissao: "CLMREATCR",
            },{
              title: "Cruzamento de Dados do Atendimento com &Palavra-Chave",
              name: "cruzamentoDeDadosDoAtendimentoComPalavraChave",
              permissao: "CLMREATPC",
            }]
          },{
            title: "Solicitações",
            name: "solicitaçõesRelatorios",
            permissao: "CLMRESO",
            separator: true,
            submenu: [{
              title: "Requisições por Paciente",
              name: "requisiçõesPorPaciente",
              permissao: "CLMRESORP"
            },{
              title: "Requisições de &Setor",
              name: "requisicoesDeSetor",
              permissao: "CLMRESORR",
              separator: true,
            },{
              title: "&Produtos por Prescrição",
              name: "produtosPorPrescricao",
              permissao: "CLMRESOPP",
            }]
          },{
            title: "Faturamento",
            name: "faturamentoRelatorios",
            permissao: "CLMREFA",
            submenu: [{
              title: "&Atendimentos por Médico",
              name: "atendimentosPorMedico",
              permissao: "CLMREFA",
            },{
              title: "Faturamento/Mov.Estoque por &Médico",
              name: "faturamentoMovEstoquePorMedico",
              permissao: "CLMREFA",
            }]
          },{
            title: "Cobrança",
            name: "cobrancaRelatorios",
            permissao: "CLMRECO",
            separator: true,
            submenu: [{
              title: "Valores Resumidos por Plano de Saúde",
              name: "valoresResumidosPorPlanoDeSaude",
              permissao: "CLMRECORC",
            },{
              title: "Cobranças Entregues",
              name: "cobrançasEntregues",
              permissao: "CLMRECOCE",
            }]
          },{
            title: "Administrativos",
            name: "administrativos",
            permissao: "CLMREAD",
            submenu: [{
              title: "Repasse Staff Médico",
              name: "repasseStaffMedico",
              permissao: "CLMREADRM"
            },{
              title: "Pacientes",
              name: "Pacientes",
              permissao: "CLMREADPI"
            }]
          },{
            title: "Auditoria",
            name: "auditoria",
            permissao: "CLMREAU",
            submenu: [{
              title: "Consistências",
              name: "consistencias",
              permissao: "CLMREAU"
            },{
              title: "Conferências",
              name: "conferencias",
              permissao: "CLMREAU"
            },{
              title: "Cadastros",
              name: "cadastros",
              permissao: "CLMREAU"
            }] 
          },{
            title: "Planilhas",
            name: "planilhas",
            permissao: "CLMREPL",
            submenu: [{
              title: "Por Planos de Saúde e Prod./Serv.",
              name: "porplanosDeSaudeEProdServ",
              permissao: "CLMREAU"
            },{
              title: "Por &Convênio e Categ.Prod./Serv.",
              name: "porConvenioECategProdServ",
              permissao: "CLMREAU"
            }]
          }]
        },
        ferramentas:{
          title: "Ferramentas",
          name: "ferramentas",
          submenu: [{
            title: "Configurações",
            name: "configuracoes",
            permissao: "CLMFECO"
          }]
        },
      }, 
      menuCash: {
        dashboard: {
          title: "Dashboard",
          name: "dashboard",
          permissao: "CSM",
          acessar: "dashboard"
        }, 
        favoritos: {
          title: "Favoritos",
          name: "favoritos",
          permissao: "CSM",
          submenu: []
        },
        fluxoCaixa: {
          title: "Fluxo de Caixa",
          name: "fluxoDeCaixa",
          permissao: "CSMMOFL",
          acessar: "fluxoDeCaixa"
        }, 
        pagar: {
          title: "Pagar",
          name: "fluxoDeCaixaPagar",
          permissao: "CSMMOFL",
          acessar: "fluxoDeCaixaPagar"
        },
        receber: {
          title: "Receber",
          name: "fluxoDeCaixaReceber",
          permissao: "CSMMOFL",
          acessar: "fluxoDeCaixaReceber"
        },
        portadoresMovimentacao: {
          title: "Conta Corrente",
          name: "portadoresMovimentacao",
          permissao: "CSMMOCC",
          acessar: "portadoresMovimentacao"
        }, 
        notasFiscais: {
          title: "Notas Fiscais",
          name: "notasFiscais",
          permissao: "CSMEMNF",
          acessar: "notasFiscais"
        }, 
        cadastros: {
          title: "Cadastros", 
          name: "cadastros", 
          permissao: "CSMCA", 
          submenu: [{
            title: "Emitentes", 
            name: "emitentes", 
            acessar: "emitentes", 
            permissao: "CSMCAEM",
          },{
            title: "Empresas", 
            name: "empresas", 
            acessar: "empresas", 
            permissao: "CSMCAEP",
          },{
            title: "Portadores", 
            name: "portadores", 
            acessar: "portadores", 
            permissao: "CSMCAPO",
          },{
            title: "Planos Financeiros", 
            name: "planosFinanceiros", 
            acessar: "planosFinanceiros", 
            permissao: "CSMCAPF",
          },{
            title: "Projetos", 
            name: "projetos", 
            acessar: "projetos", 
            permissao: "CSMCAPJ",
          },{
            title: "Contas Recorrentes", 
            name: "transacaoesRecorrentes", 
            acessar: "transacoesRecorrentes", 
            permissao: "CSMCATP",
          },{
            title: "Produtos",
            name: "produtos",
            acessar: "produtos",
            permissao: "CSMCAPR"
          },{
            title: "Tabelas",
            name: "tabelas",
            permissao: "CSMTA", 
            submenu: [{
              title: "Emitente",
              name: "emitente",
              permissao: "CSMTAEM",             
              submenu: [{
                title: "Categorias de Emitentes",
                name: "emitentesCategorias",
                acessar: "emitentesCategorias",
                permissao: "CSMTAEMCE",
              },{                
                title: "Profissões",
                name: "profissoes",
                acessar: "profissoes",
                permissao: "CSMTAEMPR"
              },{                
                title: "Tipos de Ocorrência",
                name: "tiposOcorrencia",
                acessar: "tiposOcorrencias",
                permissao: "CSMTAEMTO"
              }]},{
              title: "Financeiro",
              name: "Financeiro",
              permissao: "CSMTAFI",
              submenu: [{
                title: "Centros de Responsabilidade",
                name: "centrosResponsabilidade",
                acessar: "centrosResponsabilidade",
                permissao: "CSMTAFICR"
              }, {
                title: "Naturezas de Operação",
                name: "naturezasOperacao",
                acessar: "naturezasOperacao",
                permissao: "CSMTAFINO"
              }, {
                title: "Tipos de Multa",
                name: "tiposMulta",
                acessar: "tiposMulta",
                permissao: "CSMTAFITM"
              }, {
                title: "Moedas / Índices",
                name: "moedas",
                acessar: "moedas",
                permissao: "CSMTAFIMO"
              },{
                title: "Feriados",
                name: "feriados",
                acessar: "feriados",
                permissao: "CSMTAFE"
              }]
            },{
              title: "Produtos/Serviços",
              name: "produtosServicos",
              permissao: "CSMTAPR",
              submenu: [{
                title: "Categorias de Produtos / Serviços",
                name: "categoriasProdutosServicos",
                acessar: "produtosCategorias",
                permissao: "CSMTAPRCP"
              }]
            }]
          }]
        }, 
        relatorios: {
          title: "Relatórios", 
          name: "Relatorios", 
          permissao: "CSMRE", 
          submenu: [{
            title: "Fluxo de Caixa", 
            name: "relatoriosFluxoDeCaixa", 
            permissao: "CSMREFL", 
            submenu: [{
              title: "Projetado da Agenda Semanal", 
              name: "relatorioProjetadoAgendaSemanal", 
              acessar: "relatorioProjetadoAgendaSemanal", 
              permissao: "CSMREFLDR"
            },{
              title: "Projetado Diário por Emitente", 
              name: "relatorioProjetadoDiario", 
              acessar: "relatorioProjetadoDiario", 
              permissao: "CSMREFLDR"
            },{
              title: "DRE e DFC", 
              name: "relatorioDRE", 
              acessar: "relatorioDRE", 
              permissao: "CSMREFLDR"
            },]
          }]
        }, 
        payLogos: {
          title: "Paylogos", 
          name: "paylogos", 
          permissao: "CSM", 
          submenu: [{
            title: "Links de pagamento", name: "payLinks", acessar: "payLinks", permissao: "CSM"
          },{
            title: "Recebedores", 
            name: "payRecebedores", 
            acessar: "payRecebedores", 
            permissao: "CSM"
          },{
            title: "Maquininhas", 
            name: "payMaquininhas", 
            acessar: "payMaquininhas", 
            permissao: "CSM"
          },{
            title: "Clientes", 
            name: "payClientes", 
            acessar: "payClientes", 
            permissao: "CSM"
          }]
        }
      }, 
      menuBot: {
        recargaIA: {
          title: "Efetuar recarga de créditos",
          name: "recargaCreditosIABot",
          acessar: "recargaCreditosIABot",
          permissao: "BOT"
        },
        dashboard: {
          title: "Dashboard", 
          name: "dashboard", 
          permissao: "BOT", 
          acessar: "dashboard"
        }, 
        favoritos: {
          title: "Favoritos", 
          name: "favoritos", 
          permissao: "BOT", 
          submenu: []
        }, 
        configuracoes: {
          title: "Configurações", 
          name: "configuracoes", 
          permissao: "BOT", 
          submenu: [{
            title: "Canais de Atendimento", 
            name: "canaisAtendimentoBot", 
            acessar: "canaisAtendimentoBot", 
            permissao: "BOT"
          },{
            title: "Regras de Envio", 
            name: "regrasEnvio", 
            acessar: "regrasEnvio", 
            permissao: "BOT"
          },{
            title: "E-mail (SMTP)",
            name: "configuracoesEmailBot",
            acessar: "configuracoesEmailBot",
            permissao: "BOT"
          },{
            title: "Configurações Gerais", 
            name: "configuracoesGeraisBot", 
            acessar: "configuracoesGeraisBot", 
            permissao: "BOT"
          },{
            title: "URAs",
            name: "urasBot",
            acessar: "urasBot",
            permissao: "BOT"
          },{
            title: "Usuários",
            name: "usuariosBot",
            acessar: "usuariosBot",
            permissao: "BOT"
          },{
            title: "Mensagens Personalizadas", 
            name: "mensagensPersonalizadasBot", 
            acessar: "mensagensPersonalizadasBot", 
            permissao: "BOT"
          },{
            title: "Agentes de IA", 
            name: "agentesIA", 
            acessar: "agentesIA", 
            permissao: "BOT"
          }]
        },
        cadastros: {
          title: "Cadastros", 
          name: "cadastros", 
          permissao: "BOT", 
          submenu: [{
            title: "Gestão de Funis", 
            name: "kanbans", 
            acessar: "kanbans", 
            permissao: "BOT"
          },{
            title: "Campanhas", 
            name: "campanhas", 
            acessar: "campanhas", 
            permissao: "BOT"
          }]
        },
        relatorios: {
          title: "Relatórios",
          name: "relatorios",
          permissao: "BOT",
          submenu: [{
            title: "Envios",
            name: "relatorioEnviosBot",
            acessar: "relatorioEnviosBot",
            permissao: "BOT"
          },{
            title: "Consumo de créditos de WhatsApp", name: "relatorioConsumoWhatsAppCreditosBot", acessar: "relatorioConsumoWhatsAppCreditosBot", permissao: "BOT"
          },
          {
            title: "Recargas de créditos de WhatsApp", name: "relatorioRecargasWhatsAppCreditosBot", acessar: "relatorioRecargasWhatsAppCreditosBot", permissao: "BOT"
          },
          {
            title: "Consumo de créditos de SMS", name: "relatorioConsumoSMSCreditosBot", acessar: "relatorioConsumoSMSCreditosBot", permissao: "BOT"
          },
          {
            title: "Recargas de créditos de SMS", name: "relatorioRecargasSMSCreditosBot", acessar: "relatorioRecargasSMSCreditosBot", permissao: "BOT"
          },
          {
            title: "Consumo de créditos de IA",
            name: "relatorioConsumoIABot",
            acessar: "relatorioConsumoIABot",
            permissao: "BOT"
          },{
            title: "Recargas de créditos de IA",
            name: "relatorioRecargasIABot",
            acessar: "relatorioRecargasIABot",
            permissao: "BOT"
          }]
        }
      }, 
      menuAnalytics: {
        indicadores: { title: "Indicadores", name: "indicadores", permissao: "ANM", acessar: "indicadores" },
        dashboard: {
          title: "Dashboard", 
          name: "dashboard", 
          permissao: "ANM", 
          acessar: "dashboard"
        }, 
        favoritos: {
          title: "Favoritos", 
          name: "favoritos", 
          permissao: "ANM", 
          submenu: []
        }, 
        relatorios: {
          title: "Relatórios",
          name: "relatorios",
          permissao: "ANM", 
          submenu: [{
            title: "Talk",
            name: "relatoriosTalk",
            permissao: "ANM",
            submenu: [{
              title: "Leads",
              name: "lead",
              permissao: "ANM",
              submenu: [{
                title: "Acompanhamento de Leads",
                name: "relatorioLeads",
                acessar: "relatorioLeads",
                permissao: "ANM"
              }]
            }]
          },{
            title: "Clinic",
            name: "relatoriosClinic",
            permissao: "ANM",
            submenu: [{
              title: "Pacientes",
              name: "relatoriosClinicPacientes",
              permissao: "ANM",
              submenu: [{
                title: "Termos",
                name: "termos",
                permissao: "ANM",
                submenu: [{
                  title: "Termos enviados",
                  name: "relatorioTermos",
                  acessar: "relatorioTermos",
                  permissao: "ANM"
                }]
              }]
            }]
          }]
        }        
      }, 
      menuQuality: {
        favoritos: {
          title: "Favoritos",
          name: "favoritos",
          submenu: []
        },
        sac: {
          title: "SAC",
          name: "sac"
        },
        proposta: {
          title: "Proposta",
          name: "proposta"
        },
        agendaVisita: {
          title: "Agenda Visita",
          name: "agendaVisita"
        },
        tarefas: {
          title: "Tarefas",
          name: "tarefas"
        },
        vozChamada: {
          title: "Voz Chamada",
          name: "vozChamada"
        },
        vozRecebida: {
          title: "Voz Recebida",
          name: "vozRecebida",
          submenu: [{
            title: "Manual",
            name: "vozRecebidaManual"
          }, {
            title: "Automática",
            name: "vozRecebidaAutomatica"
          }]
        },
        projetos: {
          title: "Projetos",
          name: "projetos"
        },
        sistema: {
          title: "Sistema",
          name: "sistema",
          submenu: [{
            title: "Utilitários",
            name: "utilitarios",
            submenu: [{
              title: "Mensagens Linha Master",
              name: "mensagensLinhaMaster"
            },{
              title: "Bloco de Notas",
              name: "blocoNotas",
              separator: true
            },{
              title: "Log de Usuários Avançado",
              name: "logUsuariosAvancado"
            },{
              title: "Log de Usuários",
              name: "logUsuarios"
            },{
              title: "Ponto Eletrônico",
              name: "pontoEletronico"
            },{
              title: "Tarefas do Usuário",
              name: "tarefasUsuario",
              separator: true
            },{
              title: "Escala da Limpeza",
              name: "escalaLimpeza"
            },{
              title: "Estatísticas",
              name: "estatisticas",
              separator: true,
              submenu: [{
                title: "Estatística do SAC",
                name: "estatisticaSAC"
              },{
                title: "Ocupação do SAC",
                name: "ocupacaoSAC"
              },{
                title: "Estatísticas Gerais",
                name: "estatisticasGerais"
              }]
            },{
              title: "Telefonia",
              name: "telefonia"
            },{
              title: "Processamentos",
              name: "processamentos",
              submenu: [{
                title: "Programação de Eventos",
                name: "programacaoEventos",
              },{
                title: "Colocar Versão Atualizador",
                name: "colocarVersaoAtualizador",
              },{
                title: "Padrão MAC",
                name: "padraoMAC",
              }]
            }]
          }]
        },
        cadastros: {
          title: "Cadastros",
          name: "cadastros",
          submenu: [{
            title: "Emitentes",
            name: "emitentes",
            bold: true
          },{
            title: "Produtos / Serviços",
            name: "produtosServicos",
            submenu: [{
              title: "Serviços",
              name: "servicos"
            },{
              title: "Produtos",
              name: "produtos"
            }]
          },{
            title: "Representantes",
            name: "representantes",
            separator: true
          },{
            title: "Tabelas",
            name: "tabelas",
            submenu: [{
              title: "Atendimentos",
              name: "atendimentos",
              bold: true,
              submenu: [{
                title: "Categorias de Textos",
                name: "categoriasTextos",
                bold: true
              },{
                title: "Textos",
                name: "textos",
                bold: true
              },{
                title: "Condições de Pagamento",
                name: "condicoesPagamento"
              },{
                title: "Centros de Responsabilidade",
                name: "centrosResponsabilidade"
              },{
                title: "Pacotes",
                name: "pacotes"
              },{
                title: "Finalidades",
                name: "finalidades",
                separator: true
              },{
                title: "Tipos de Atendimentos",
                name: "tiposAtendimentos"
              },{
                title: "Tipos de Ocorrências",
                name: "tiposOcorrencias"
              }]
            },{
              title: "Agenda",
              name: "agenda",
              submenu: [{
                title: "Tarefas",
                name: "tarefas"
              },{
                title: "Processos",
                name: "processos"
              }]
            },{
              title: "Emitentes",
              name: "emitentes",
              submenu: [{
                title: "Categorias de Emitente",
                name: "categoriasEmitente",
                bold: true
              },{
                title: "Tipos de Relação de Emitente",
                name: "tiposRelacaoEmitente"
              },{
                title: "Facilitadores",
                name: "facilitadores"
              }]
            },{
              title: "Produtos / Serviços",
              name: "produtosServicos",
              submenu: [{
                title: "Categorias de Produto / Serviço",
                name: "categoriasProdutoServico",
                bold: true
              },{
                title: "Unidade de Medida",
                name: "unidadeMedida"
              },{
                title: "Grupos",
                name: "grupos"
              },{
                title: "Marcas (Fabricantes)",
                name: "marcasFabricantes"
              },{
                title: "Preços",
                name: "precos"
              },{
                title: "Tipos de Comissão",
                name: "tiposComissao"
              }]
            },{
              title: "Diversos",
              name: "diversos",
              submenu: [{
                title: "Feriados",
                name: "feriados"                
              },{
                title: "Moedas Estrangeiras",
                name: "moedasEstrangeiras",
              },{
                title: "CEP",
                name: "cep",
              }]
            }]
          }]
        },
        agendas: {
          title: "Agendas",
          name: "agendas",
          submenu: [{
            title: "Visitas",
            name: "Visitas"
          },{
            title: "Procedimentos",
            name: "procedimentos",
            bold: true,
            separator: true
          },{
            title: "Programação de Eventos",
            name: "programacaoEventos",
          },{
            title: "Projetos",
            name: "projetos",
          }]
        },
        atendimentos: {
          title: "Atendimentos",
          name: "atendimentos",
          submenu: [{
            title: "Comunicação por Voz",
            name: "comunicacaoVoz",
            separator: true
          },{
            title: "SAC",
            name: "sac"
          },{
            title: "NAs sem preenchimento",
            name: "nasSemPreenchimento"
          },{
            title: "SAC novo (em desenv)",
            name: "sacNovo"
          },{
            title: "Dúvidas Frequentes",
            name: "duvidasFrequentes"
          },{
            title: "Objetivo Solução de NA",
            name: "objetivoSolucaoNA",
            separator: true
          },{
            title: "Requisições Encerradas",
            name: "requisicoesEncerradas"
          }]
        },
        comercial: {
          title: "Comercial",
          name: "comercial",
          submenu: [{
            title: "Proposta",
            name: "proposta",
            bold: true
          },{
            title: "Administração de Licenças",
            name: "administracaoLicencas"
          },{
            title: "Resultado Pesquisa Satisfação",
            name: "resultadoPesquisaSatisfacao",
            separator: true
          },{
            title: "Rastreio Emitente",
            name: "rastreioEmitente"
          },{
            title: "Acompanhamento Web",
            name: "acompanhamentoWeb"
          }]
        },
        relatorios: {
          title: "Relatórios",
          name: "relatorios",
          submenu: [{
            title: "Agenda",
            name: "agenda"
          },{
            title: "Atendimento",
            name: "atendimento",
            submenu: [{
              title: "Estatísticas de Atendimento",
              name: "estatisticasAtendimento"
            },{
              title: "Atendimentos por Peso",
              name: "atendimentosPeso"
            }]
          },{
            title: "Comercial",
            name: "comercial",
            submenu: [{
              title: "Contratos ativos por Pacote",
              name: "contratosAtivosPacote"
            }]
          },{
            title: "Emitentes",
            name: "emitentes",
            submenu: [{
              title: "Configurado de Emitentes",
              name: "configuradoEmitentes"
            }]
          },{
            title: "Administrativos",
            name: "administrativos",
            submenu: [{
              title: "Ponto Eletrônico",
              name: "pontoEletronico"
            },{
              title: "Banco de Horas",
              name: "bancoHoras"
            },{
              title: "ValoresExtrasRepresentantes",
              name: "valoresExtrasRepresentantes"
            }]
          }]
        },
        ferramentas: {
          title: "Ferramentas",
          name: "ferramentas",
          submenu: [{
            title: "Configuração",
            name: "configuracao",
            separator: true,
            submenu: [{
              title: "Sistema",
              name: "sistema",
              bold: true,
              separator: true
            },{
              title: "Recebe Mensagem",
              name: "recebeMensagem"
            },{
              title: "Volta config. inicial da tela",
              name: "voltaConfigInicialTela"
            }]
          },{
            title: "Manutenção de Arquivos",
            name: "manutencaoArquivos",
            submenu: [{
              title: "Manutenção Completa",
              name: "manutencaoCompleta"
            },{
              title: "Cópia dos Dados - Backup",
              name: "copiaDadosBackup"
            }]
          },{
            title: "Ocupação dia seguinte",
            name: "ocupacaoDiaSeguinte",
            bold: true,
            separator: true
          },{
            title: "Cascata",
            name: "cascata"
          },{
            title: "Calendário",
            name: "calendario",
            separator: true
          },{
            title: "Perfil",
            name: "perfil",
            separator: true
          },{
            title: "Suporte Autorizado",
            name: "suporteAutorizado"
          }]
        },
        ajuda: {
          title: "Ajuda",
          name: "ajuda",
          submenu: [{
            title: "Conteúdo",
            name: "conteudo",
            bold: true
          },{
            title: "Sobre o Sistema",
            name: "sobreSistema",
            separator: true
          },{
            title: "Suporte Técnico",
            name: "suporteTecnico"
          }]
        }
      }, 
      collapseAcessos: true
    };
  },
  async mounted() {
    acessosIndicadores.set(this,carregadorIndicadores());
    this.atualizarAcessoIndicadores();
    this.permissoes = await this.getPermissoes();

    this.inicializaMenu();
    this.verificaPermissao();

    this.emitter.on("atualizarMenuFavoritos", () => {
      this.buscarMenusFavoritos();
    });
    this.emitter.on("indicadoresAcessoAlterado", this.atualizarAcessoIndicadores);

    this.buscarMenusFavoritos();
  }, 
  beforeUnmount() {
    acessosIndicadores.get(this)?.cancelar();
    acessosIndicadores.delete(this);
    this.emitter.off("indicadoresAcessoAlterado", this.atualizarAcessoIndicadores);
    this.emitter.off("atualizarMenuFavoritos");
  }, 
  computed: {
    ...mapGetters([
      "fgSistema", 
      "acessaSpirit", 
      "perfis", "usuario", "idEmitenteML", "loadingUserInfo"
    ]),
    contextoIndicadores(){return JSON.stringify([this.fgSistema,this.usuario,this.idEmitenteML,this.loadingUserInfo]);}
  }, 
  watch: {
    contextoIndicadores(){this.atualizarAcessoIndicadores();},
    async acessaSpirit() {
      this.permissoes = await this.getPermissoes();
      
      this.inicializaMenu();
      this.verificaPermissao();
    }, 
    perfis: {
      deep: true, 
      async handler() {
        this.permissoes = await this.getPermissoes();

        this.inicializaMenu();
        this.verificaPermissao();
      }
    }
  }, 
  methods: {
    atualizarAcessoIndicadores(){
      const controle=acessosIndicadores.get(this);if(!controle){return;}
      controle.cancelar();this.indicadoresPermitido=false;this.menuAnalytics.indicadores.visible=false;
      if(this.fgSistema!=="ANALYTICS"||this.loadingUserInfo){return;}
      return controle.carregar("acessoUsuario",{},dados=>{this.indicadoresPermitido=dados.permitido===true;this.verificaPermissao();},()=>{},()=>{});
    },
    ...mapActions([
      "getPermissoes", 
      "updatePermissoes", 
      "sleepTime", 
      "listarMenusFavoritos"
    ]), 
    inicializaMenu() {
      Object.entries(this.menuClinic).forEach(item => {
        item[1].visible = false;

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.inicializaMenuRecursiva(item[1].submenu);
        }
      });

      Object.entries(this.menuCash).forEach(item => {
        item[1].visible = false;

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.inicializaMenuRecursiva(item[1].submenu);
        }
      });

      Object.entries(this.menuBot).forEach(item => {
        item[1].visible = false;

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.inicializaMenuRecursiva(item[1].submenu);
        }
      });
      
      Object.entries(this.menuAnalytics).forEach(item => {
        item[1].visible = false;

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.inicializaMenuRecursiva(item[1].submenu);
        }
      });
    },
    inicializaMenuRecursiva(submenus) {
      submenus.forEach(submenu => {
        if(submenu) {
          submenu.visible = false;

          if((submenu.submenu) && (submenu.submenu.length)) {
            this.inicializaMenuRecursiva(submenu.submenu);
          }
        }
      });
    },
    verificaPermissao() {
      Object.entries(this.menuClinic).forEach(item => {
        this.permissoes.forEach(perfil => {
          perfil.forEach(permissao => {
            if((permissao.TAREFA == item[1].permissao) || (permissao.PERFIL == "00")) {
              this.permissoesAtivas.forEach((permissaoAtiva) => {
                if(((item[1].permissao == permissaoAtiva) || (this.buscaMenus == "123456")) && (((item[1].permissao == "CLMATAT") && (this.acessaSpirit)) || (item[1].permissao !== "CLMATAT"))) {
                  item[1].visible = true;
                }
              });
            }
          });        
        });

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.verificaPermissaoRecursiva(item[1].submenu);
        }
      });

      Object.entries(this.menuCash).forEach(item => {
        this.permissoes.forEach(perfil => {
          perfil.forEach(permissao => {
            if((permissao.TAREFA == item[1].permissao) || (permissao.PERFIL == "00")) {
              this.permissoesAtivas.forEach((permissaoAtiva) => {
                if((item[1].permissao == permissaoAtiva) || (this.buscaMenus == "123456")) {
                  item[1].visible = true;
                }
              });
            }
          });        
        });

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.verificaPermissaoRecursiva(item[1].submenu);
        }
      });

      Object.entries(this.menuBot).forEach(item => {
        this.permissoes.forEach(perfil => {
          perfil.forEach(permissao => {
            if((permissao.TAREFA == item[1].permissao) || (permissao.PERFIL == "00")) {
              this.permissoesAtivas.forEach((permissaoAtiva) => {
                if((item[1].permissao == permissaoAtiva) || (this.buscaMenus == "123456")) {
                  item[1].visible = true;
                }
              });
            }
          });        
        });

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.verificaPermissaoRecursiva(item[1].submenu);
        }
      });

      Object.entries(this.menuAnalytics).forEach(item => {
        this.permissoes.forEach(perfil => {
          perfil.forEach(permissao => {
            if((permissao.TAREFA == item[1].permissao) || (permissao.PERFIL == "00")) {
              this.permissoesAtivas.forEach((permissaoAtiva) => {
                if((item[1].permissao == permissaoAtiva) || (this.buscaMenus == "123456")) {
                  item[1].visible = true;
                }
              });
            }
          });        
        });

        if((item[1].submenu) && (item[1].submenu.length)) {
          this.verificaPermissaoRecursiva(item[1].submenu);
        }
      });

      this.menuAnalytics.indicadores.visible = this.indicadoresPermitido && this.fgSistema === "ANALYTICS";
      this.updatePermissoes(this.permissoes);
    },
    verificaPermissaoRecursiva(submenus) {
      submenus.forEach(submenu => {
        if(submenu) {
          this.permissoes.forEach(perfil => {
            perfil.forEach(permissao => {
              if((permissao.TAREFA == submenu.permissao) || (permissao.PERFIL == "00")) {
                this.permissoesAtivas.forEach((permissaoAtiva) => {
                  if(((submenu.permissao == permissaoAtiva) || (this.buscaMenus == "123456")) && (((submenu.permissao == "CLMATAT") && (this.acessaSpirit)) || (submenu.permissao !== "CLMATAT"))) {
                    submenu.visible = true;
                  }
                });

              }
            });
          });

          if((submenu.submenu) && (submenu.submenu.length)) {
            this.verificaPermissaoRecursiva(submenu.submenu);
          }
        }
      });
    },
    async buscarMenusFavoritos() {
      let favoritos = await this.listarMenusFavoritos();

      this.menuClinic.favoritos.submenu = [];
      this.menuCash.favoritos.submenu = [];
      this.menuBot.favoritos.submenu = [];
      this.menuAnalytics.favoritos.submenu = [];
      favoritos.forEach((favorito) => {
        if(favorito.ACESSO) {
          let menu = this.buscarMenuPeloAcesso(favorito.ACESSO);
          if(this.fgSistema == "CLINIC") {
            this.menuClinic.favoritos.submenu.push(menu);
          } else if(this.fgSistema == "CASH") {
            this.menuCash.favoritos.submenu.push(menu);
          } else if(this.fgSistema == "BOT") {
            this.menuBot.favoritos.submenu.push(menu);
          } else if(this.fgSistema == "ANALYTICS") {
            this.menuAnalytics.favoritos.submenu.push(menu);
          }
        }        
      });
    }, 
    buscarMenuPeloAcesso(acesso) {
      let menu = null;
      let menusSuperior = [];

      if(this.fgSistema == "CLINIC") {
        menusSuperior = Object.entries(this.menuClinic);
      } else if(this.fgSistema == "CASH") {
        menusSuperior = Object.entries(this.menuCash);
      } else if(this.fgSistema == "BOT") {
        menusSuperior = Object.entries(this.menuBot);
      } else if(this.fgSistema == "ANALYTICS") {
        menusSuperior = Object.entries(this.menuAnalytics);
      }

      for(let index = 0; index < menusSuperior.length; index++) {
        const item = menusSuperior[index];
        
        if((item[1]) && (item[1].acessar) && (item[1].acessar == acesso)) {
          menu = item[1];
          break;
        }

        if((item[1]) && (item[1].submenu) && (item[1].submenu.length)) {
          menu = this.buscarMenuPeloAcessoRecursiva(item[1].submenu, acesso);

          if(menu) {
            break;
          }
        }
      }

      return menu;      
    }, 
    buscarMenuPeloAcessoRecursiva(submenu, acesso) {
      let menu = null;

      for(let index = 0; index < submenu.length; index++) {
        const item = submenu[index];

        if(item) {
          if((item.acessar) && (item.acessar == acesso)) {
            menu = item;
            break;
          }

          if((item.submenu) && (item.submenu.length)) {
            menu = this.buscarMenuPeloAcessoRecursiva(item.submenu, acesso);

            if(menu) {
              break;
            }
          }
        }
      }

      return menu;
    }
  }
}
</script>

<style scoped>

</style>
